import { render, staticRenderFns } from "./CountryReference.vue?vue&type=template&id=089d1ca3"
import script from "./CountryReference.vue?vue&type=script&lang=ts"
export * from "./CountryReference.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports